import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { environment } from './../../../../../environments/environment';
import { ServiceBase } from './../../../../shared/service-base/ServiceBase';

@Injectable()
export class FamiliaService extends ServiceBase {
  private baseUrlService: string;

  constructor(
    http: HttpClient,
    router: Router
  ) {
    super(http, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/cruzamento_veiculos_familia`;
  }

  /**
   * Busca todas as famílias com seus vínculos
   */
  public getFamilias(): Promise<any> {
    return this.get([]);
  }

  /**
   * Adiciona uma nova família
   */
  public adicionarFamilia(nome: string): Promise<any> {
    const url = this.getURL();
    const body = {
      descProduto: nome
    };
    const options = (this as any).getOptions();
    
    return (this as any).http.post(url, body, options)
      .toPromise()
      .then((this as any).tratarRetorno);
  }

  /**
   * Remove uma família
   */
  public removerFamilia(id: number): Promise<any> {
    const url = `${this.getURL()}?idVeicFamilia=${id}`;
    const options = (this as any).getOptions();
    
    return (this as any).http.delete(url, options)
      .toPromise()
      .then((this as any).tratarRetorno);
  }

  /**
   * Atualiza uma família existente
   */
  public atualizarFamilia(id: number, nome: string): Promise<any> {
    const parametros = [
      { nome: 'idPadraoVeiculos', valor: id.toString() }
    ];
    const body = {
      descProduto: nome
    };
    return this.atualizar(body, parametros);
  }

  /**
   * Busca uma família específica por ID
   */
  public getFamiliaPorId(id: number): Promise<any> {
    const parametros = [
      { nome: 'idPadraoVeiculos', valor: id.toString() }
    ];
    return this.get(parametros);
  }

  /**
   * Verifica se uma família pode ser removida (sem vínculos ativos)
   */
  public verificarVinculosFamilia(id: number): Promise<any> {
    const parametros = [
      { nome: 'idPadraoVeiculos', valor: id.toString() }
    ];
    return this.get(parametros);
  }

  /**
   * Busca os vínculos de uma família específica
   */
  public getVinculosFamilia(idFamilia: number): Promise<any> {
    const url = `${this.getURL()}/vinculos?idVeicFamilia=${idFamilia}`;
    const options = (this as any).getOptions();
    
    return (this as any).http.get(url, options)
      .toPromise()
      .then((response: any) => {
        return (this as any).tratarRetorno(response);
      })
      .catch((error: any) => {
        console.error('Erro na requisição de vínculos:', error);
        throw error;
      });
  }

  /**
   * Salva os vínculos de uma família
   */
  public salvarVinculosFamilia(idFamilia: number, elementosVinculados: any[]): Promise<any> {
    const url = `${this.getURL()}/vincular?idVeicFamilia=${idFamilia}`;
    const body = {
      descVeiculos: elementosVinculados.map(elemento => ({
        produto: elemento.nome,
        criadoPor: elemento.criadoPor,
        idDealer: elemento.idDealer
      }))
    };
    const options = (this as any).getOptions();
    
    return (this as any).http.post(url, body, options)
      .toPromise()
      .then((response: any) => {
        return (this as any).tratarRetorno(response);
      })
      .catch((error: any) => {
        console.error('Erro ao salvar vínculos:', error);
        throw error;
      });
  }
}

